import { HTMLAttributes, useEffect, useState } from 'react';
import { ValidationStatus, formatSnakeCase } from '@jove-frontend/uikit';
import { Close, Done } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { capitalize } from 'lodash';

type ValidationStatusViewProps = HTMLAttributes<HTMLDivElement> & {
  status: string;
  addPrefixIcon?: boolean;
};

const ValidationStatusView = (props: ValidationStatusViewProps) => {
  const { className, status, addPrefixIcon } = props;
  const [containerStyle, setContainerStyle] = useState({});
  const [showText, setShowText] = useState('');
  const [prefixIcon, setPrefixIcon] = useState(null);

  /**
   * effects
   */
  useEffect(() => {
    evaluateTextInfo();
  }, [status]);

  /**
   * methods
   */
  const evaluateTextInfo = () => {
    let showText = capitalize(formatSnakeCase(status));
    let textColor = '#0E35D1';
    let prefixIcon = null;

    switch (status) {
      case ValidationStatus.NOT_STARTED:
        textColor = '#707070';
        break;
      case ValidationStatus.PAYE_CONTRACTOR:
        textColor = '#474747';
        break;
      case ValidationStatus.SUCCESS:
        textColor = '#1CB258';
        prefixIcon = <Done className={`h-4 w-4 text-${textColor}`} />;
        break;
      case ValidationStatus.CANCELLED:
      case ValidationStatus.EXPIRED:
        textColor = '#DD1F1F';
        break;
      case ValidationStatus.EXPIRE_SOON:
      case ValidationStatus.URGENT_EXPIRING:
        textColor = '#E76F2B';
        break;
      case ValidationStatus.FAIL:
        textColor = '#DD1F1F';
        prefixIcon = <Close className={`h-4 w-4 text-${textColor}`} />;
        break;
      default:
        break;
    }

    // Special handle
    if (status === ValidationStatus.IN_PROGRESS) {
      showText = 'Pending';
    }

    setPrefixIcon(prefixIcon);
    setShowText(showText);
    setContainerStyle({
      borderColor: `${textColor}`,
      color: `${textColor}`,
    });
  };

  if (!status) {
    return null;
  }

  return (
    <Box
      style={containerStyle}
      className={clsx(
        'inline-flex flex-row items-center space-x-1 rounded-lg border px-[8px] py-[6px] text-sm font-bold leading-4',
        className
      )}
    >
      {addPrefixIcon ? prefixIcon : null}
      <Typography variant="subtitle2" className="font-bold">
        {showText}
      </Typography>
    </Box>
  );
};

export default ValidationStatusView;
